/* eslint-disable import/no-unused-modules */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { IBacOrganization } from "container/bac/interface/bac.interface";
import { RootState } from "redux/store.js";

interface IInitialState {
  BacOrganzation: IBacOrganization;
  id: string;
  vehicle: { id: string };
  policies: { lineOfBusiness: { value: string } }[];
}
const initialState: IInitialState = {
  id: "",
  BacOrganzation: {
    id: "",
    logoKey: "",
    name: "",
    description: "",
    value: "",
    partnerName: "",
    contactNumber: "",
    email: "",
    address: "",
    isActive: true,
    updatedBy: "",
    updatedById: ""
  },
  vehicle: {
    id: ""
  },
  policies: {} as { lineOfBusiness: { value: string } }[]
};

const bacOrganizationSlice = createSlice({
  name: "bacOrganization",
  initialState,
  reducers: {
    AddBacOrganization: (state, action) => {
      state.BacOrganzation = action.payload;
    },
    AddMemberId: (state, action) => {
      state.id = action.payload;
    },
    AddVehicle: (state, action) => {
      state.vehicle = action.payload;
    },
    DeleteBacOrganization: state => {
      state.BacOrganzation = initialState.BacOrganzation;
    },
    AddPolicies: (state, action) => {
      state.policies = action.payload;
    }
  }
});

export const { AddBacOrganization, DeleteBacOrganization, AddMemberId, AddVehicle, AddPolicies } = bacOrganizationSlice.actions;
export default bacOrganizationSlice.reducer;

export const getBacOrganization = (state: RootState): IInitialState => state?.bacOrganization;

export const getPolicies = (state: RootState) => state.bacOrganization.policies;
